import { createGlobalStyle } from 'styled-components'
import theme from './theme'

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial,
    sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    color: ${theme.color.action};
    text-decoration: underline;

    &:hover {
      color: ${theme.color.text};
      text-decoration: underline;
    }

    &:focus {
      outline: 3px solid ${theme.color.focus};
      outline-offset: 2px;
      border-radius: 0;
    }
  }

  p {
    color: ${theme.color.text};
    font-size: 1rem;
    line-height: 1.25rem;
  }
`

export default GlobalStyle
